module.exports = __webpack_public_path__ + "img/vg.cb98f184.svg";